<app-tab-stakeholder-detail-houding [stakeholder]="stakeholder"  [showCharts]="true" [showInterests]="false" [showStrategyField]="true"></app-tab-stakeholder-detail-houding>
